import {LabelerTask} from "@/fyneai-shared/types";
import React, {ReactElement} from "react";
import {Button, Typography, useMediaQuery, useTheme} from "@mui/material";
import {ExpandMoreOutlined, TaskAltOutlined} from "@mui/icons-material";
import {DialogFragment, PageFragmentProps, PageFragmentState} from "@/shared/PageFragment";
import {PAGE_FRAGMENT_WIDTH, PD_LG, PD_SM, PD_XXSM, SZ_JUMBO} from "@/shared/dimens";
import {LabelerTasksListView} from "./LabelerTasksListView";
import {BaseApp} from "@/shared/BaseApp";
import {StyledBoxColumn} from "@/shared/StyledComponents";

export type LabelerTaskSelectFragmentProps = PageFragmentProps & {
  title?: string,
  tasks: LabelerTask[],
  selectedTask: LabelerTask,
  setSelectedTask: (task: LabelerTask) => void,
  style?: any,
}

type LabelerTaskSelectFragmentState = PageFragmentState & {}

export class LabelerTaskSelectFragment extends DialogFragment<LabelerTaskSelectFragmentProps, LabelerTaskSelectFragmentState> {

  protected onCreateState(props: LabelerTaskSelectFragmentProps): LabelerTaskSelectFragmentState {
    return {
      ...super.onCreateState(props),
      title: props.title,
    };
  }

  renderContent(): ReactElement {
    return <StyledBoxColumn style={{...this.props.style, padding: PD_SM}}>
      <LabelerTasksListView
        tasks={this.props.tasks}
        selectedTask={this.props.selectedTask}
        setSelectedTask={selectedTask => this.props.setSelectedTask(selectedTask)}/>
    </StyledBoxColumn>
  }
}

export function LabelerTaskSelect({tasks, selectedTask, setSelectedTask}: {tasks: LabelerTask[], selectedTask: LabelerTask, setSelectedTask: (task: LabelerTask)=>void}): ReactElement {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  return <Button
    startIcon={<TaskAltOutlined/>}
    endIcon={<ExpandMoreOutlined/>}
    style={{
      flexShrink: 0,
      minWidth: 0,
      maxWidth: SZ_JUMBO,
      minHeight: 40,
      padding: `${PD_XXSM}px ${PD_LG}px`
    }}
    onClick={() => {
      const id = BaseApp.CONTEXT.showDialog(null, () =>
        <LabelerTaskSelectFragment
          title={"Select Task"}
          style={{width: "84dvw", minHeight: 360, maxWidth: PAGE_FRAGMENT_WIDTH}}
          tasks={tasks}
          selectedTask={selectedTask}
          setSelectedTask={(task) => {
            BaseApp.CONTEXT.hideDialog(id);
            if (task) {
              setSelectedTask(task);
            }
          }}
        />);
    }}>
    {md
      ? (selectedTask
        ? <Typography variant="body2" noWrap={true}>{selectedTask.name}</Typography>
        : <Typography variant={"body2"}><i>Tap to select task</i></Typography>)
      : null}
  </Button>
}